var _style, _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHubLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 142.3 56",
    style: {
      enableBackground: "new 0 0 142.3 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000034774277267232561010000001908410281338123447_);}\n\t.st1{fill:#004E2B;}\n\t.st2{fill:#00DD39;}\n\t.st3{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 56,
    height: 56
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181789676389787729280000014870048222093376691_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181789676389787729280000014870048222093376691_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.2,0H16.8C7.5,0,0,7.5,0,16.8v22.5C0,48.5,7.5,56,16.8,56h22.5C48.5,56,56,48.5,56,39.2V16.8 C56,7.5,48.5,0,39.2,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.1,11.2h-6.9v6.9h6.9V11.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.1,11.2h-6.9v6.9h6.9V11.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33,11.2h-7.9v6.9H33c2.6,0,4.8,2.2,4.8,4.8v14.8H22.9c-2.6,0-4.8-2.2-4.8-4.8v-7.9h-6.9V33 c0,6.5,5.2,11.7,11.7,11.7h21.8V22.9C44.7,16.4,39.4,11.2,33,11.2z"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.2,26.4v-8.8h5.4V40h-5.4v-8.7H78.9V40h-5.4V17.6h5.4v8.8H89.2z M112.1,32.3V23h5.1v17h-4.8l-0.2-2.3 c-1.2,1.5-3.4,2.7-6.1,2.7c-4.1,0-6.6-2.8-6.6-7.6V23h5.1v8.9c0,2.6,1.1,4,3.5,4C110.4,35.9,112.1,34.5,112.1,32.3z M133.4,22.7 c4.8,0,8.5,3.7,8.5,8.8c0,5.2-3.6,8.9-8.5,8.9c-2.5,0-4.6-0.9-6-2.2l-0.1,1.8h-4.8V16.3h5.2v8.4C129,23.6,131.1,22.7,133.4,22.7z  M132.2,36c2.8,0,4.7-1.8,4.7-4.5c0-2.7-1.9-4.5-4.7-4.5c-2.9,0-4.8,1.8-4.8,4.5C127.4,34.2,129.3,36,132.2,36z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubLogo);
export default __webpack_public_path__ + "static/media/Hub-Logo.7ec6aed8aa3c68bf7fd1394de58050b0.svg";
export { ForwardRef as ReactComponent };